var productName = 'schedulerpro';// File is symlinked with "grunt symlink" task
export * from './webpack.core.entry.wc.js';
// region WebComponents
export { default as TimelineBaseTag } from '../lib/Scheduler/customElements/TimelineBaseTag.js';
export { default as SchedulerTag } from '../lib/Scheduler/customElements/SchedulerTag.js';
export { default as SchedulerProTag } from '../lib/SchedulerPro/customElements/SchedulerProTag.js';
// endregion
